/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { DownloadCardsSectionFragment } from "@cosmos/hygraph-schema";
import { ResponsiveContainer, SectionHeading, BackgroundContainer, SectionContainer } from "@components/elements";
import { DownloadSteps, DownloadStepsProps } from "./DownloadSteps.organism";
import { VStack } from "@panda/jsx";

export interface DownloadCardsSectionProps extends Omit<DownloadCardsSectionFragment, "__typename" | "id" | "steps"> {
	steps?: DownloadStepsProps;
}

export const DownloadCardsSection = ({
	config,
	steps,
	footer,
}: DownloadCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(
		steps?.length || footer?.title || footer?.titleIcon || footer?.description || footer?.cta,
	);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
			bgBlur
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="download-cards-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <DownloadSteps steps={steps || []} footer={footer} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
